import React from "react";
var __jsx = React.createElement;
import stl from "../../StaticPage.module.css";
import BreadCrumb from "@componentsShared/BreadCrumb";
import { useTranslation } from "@i18n";
import LatestUpdateData from "@/pages/static-page/ui/LatestUpdateData";
import useIsWebView from "@hooks/useIsWebview";
var PrivacyPolicy = function PrivacyPolicy(_ref) {
  var title = _ref.title,
    published_date = _ref.published_date,
    content = _ref.content,
    _ref$hideBreadCrumb = _ref.hideBreadCrumb,
    hideBreadCrumb = _ref$hideBreadCrumb === void 0 ? false : _ref$hideBreadCrumb;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isWebView = useIsWebView();
  var showBreadCrumb = !hideBreadCrumb && !isWebView;
  return /*#__PURE__*/React.createElement("section", {
    className: stl.Content
  }, showBreadCrumb && /*#__PURE__*/React.createElement(BreadCrumb, {
    className: "mt-1 ms-0",
    links: [{
      title: t("privacy_policy", {
        ns: "web_footer"
      })
    }]
  }), /*#__PURE__*/React.createElement("h1", null, title), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: content
    }
  }), /*#__PURE__*/React.createElement(LatestUpdateData, {
    dateString: published_date
  }));
};
export default PrivacyPolicy;